module.exports = __webpack_public_path__ + "media/2019-video.68ffcc48.webm";